<template>
  <div v-if="dataAppointments">

    <form-wizard
      v-show="!isSubmitting"
      color="#B5C62C"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Enviar"
      back-button-text="Atras"
      next-button-text="Siguiente"
      class="wizard-vertical mb-3"
      @on-complete="formSubmitted"
    >

      <!-- account datails tab -->
      <tab-content
        title="Usuario registrado"
        :before-change="validationUserLogin"
      >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Usuario registrado
            </h5>
            <small class="text-muted">
              Eres un usuario registrado.
            </small>
          </b-col>

          <b-col
            v-if="!user"
            lg="12"
            class="d-flex align-items-center auth-bg px-4 p-lg-5"
          >
            <b-col
              sm="8"
              md="6"
              lg="8"
              class="px-xl-2 mx-auto"
            >
              <b-card-text class="mb-2">
                Si ya tienes un usuario <b>odontólogo</b> creado inicia sesión
              </b-card-text>

              <validation-observer
                ref="loginForm"
                #default="{invalid}"
              >
                <b-form
                  class="auth-login-form mt-2"
                  @submit.prevent="login"
                >
                  <!-- email -->
                  <b-form-group
                    label="Email / Usuario"
                    label-for="login-email"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Email / Usuario"
                      vid="email"
                      rules="required"
                    >
                      <b-form-input
                        id="login-email"
                        v-model="userEmail"
                        :state="errors.length > 0 ? false:null"
                        name="login-email"
                        placeholder="john@example.com"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <!-- forgot password -->
                  <b-form-group>
                    <div class="d-flex justify-content-between">
                      <label for="login-password">Contraseña</label>
                      <!--                  <b-link :to="{name:'auth-forgot-password'}">
                    <small>Forgot Password?</small>
                  </b-link>-->
                    </div>
                    <validation-provider
                      #default="{ errors }"
                      name="Contraseña"
                      vid="password"
                      rules="required"
                    >
                      <b-input-group
                        class="input-group-merge"
                        :class="errors.length > 0 ? 'is-invalid':null"
                      >
                        <b-form-input
                          id="login-password"
                          v-model="password"
                          :state="errors.length > 0 ? false:null"
                          class="form-control-merge"
                          :type="passwordFieldType"
                          name="login-password"
                          placeholder="Contraseña"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            class="cursor-pointer"
                            :icon="passwordToggleIcon"
                            @click="togglePasswordVisibility"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-button
                    type="submit"
                    block
                    :disabled="invalid || loading"
                    :variant="loading ? 'secondary' : 'primary'"
                  >
                    <b-spinner
                      v-if="loading"
                      small
                      class="mr-2"
                    />
                    {{ loading ? 'Iniciando sesión...' : 'Inicia sesión' }}
                  </b-button>

                </b-form>
              </validation-observer>

              <div
                v-if="errors.user"
                class="text-danger mt-2"
              >
                {{ errors.user }}
              </div>

              <!--              <b-card-text class="mt-4 mb-2 text-center">
                Si no tienes usaurio puedes continuar sin iniciar sesión haciendo clic en el botón <b>"Siguiente"</b>.
              </b-card-text>-->

            </b-col>
          </b-col>

          <b-col
            v-else
            lg="12"
            class="px-4 p-lg-5"
          >
            <div class="text-center">
              <h2 class="mb-1">
                ¡Genial! Ya estás dentro
              </h2>
              <p class="mb-3">
                <b>{{ user.first_name }}</b> sigue los pasos para agendar tus pacientes de manera ágil y sencilla.<br>
                Haz clic en <b>'Siguiente'</b> para continuar.
              </p>
            </div>
          </b-col>

        </b-row>
      </tab-content>

      <!-- personal info tab -->
      <tab-content
        title="Tipo de servicio"
        :before-change="validationServicesForm"
      >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Tipo de servicio
            </h5>
            <small class="text-muted">Seleccione el tipo de servicio.</small>
          </b-col>

          <b-col md="12">
            <b-form-group
              label="Tipo de servicio *"
              label-cols-sm="12"
            >
              <b-button-group>
                <b-button
                  v-for="option in services"
                  :key="option.value"
                  :variant="form.schedule_service_type_id === option.value ? 'primary' : 'outline-secondary'"
                  class="rounded-pill px-2 font-weight-bold mr-1 mb-1"
                  @click="form.schedule_service_type_id = option.value"
                >
                  {{ option.text }}
                </b-button>
              </b-button-group>
              <div
                v-if="errors.schedule_service_type_id"
                class="text-danger"
              >
                {{ errors.schedule_service_type_id }}
              </div>
            </b-form-group>
          </b-col>

          <b-col
            v-if="form.schedule_service_type_id == 1"
            md="12"
          >
            <b-form-group
              label="Tipo de escaneo*"
              label-cols-sm="12"
            >
              <b-button-group>
                <b-button
                  v-for="option in scanTypes"
                  :key="option.value"
                  :variant="form.scan_type_id === option.value ? 'primary' : 'outline-secondary'"
                  class="rounded-pill px-2 font-weight-bold mr-1 mb-1"
                  @click="form.scan_type_id = option.value"
                >
                  {{ option.text }}
                </b-button>
              </b-button-group>
              <div
                v-if="errors.scan_type_id"
                class="text-danger"
              >
                {{ errors.scan_type_id }}
              </div>
            </b-form-group>
          </b-col>

          <b-col
            v-if="form.schedule_service_type_id == 2"
            md="12"
          >
            <b-form-group
              label="Impresión de modelo"
              label-cols-sm="12"
            >
              <b-button-group>
                <b-button
                  v-for="option in modelTypes"
                  :key="option.value"
                  :variant="form.model_type === option.value ? 'primary' : 'outline-secondary'"
                  class="rounded-pill px-2 font-weight-bold mr-1 mb-1"
                  @click="form.model_type = option.value"
                >
                  {{ option.text }}
                </b-button>
              </b-button-group>
              <div
                v-if="errors.model_type"
                class="text-danger"
              >
                {{ errors.model_type }}
              </div>
            </b-form-group>
          </b-col>

        </b-row>
      </tab-content>

      <!-- address -->
      <tab-content
        title="Datos de la clínica"
        :before-change="validationClinicDataForm"
      >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Datos de la clínica
            </h5>
            <small class="text-muted">Ingresa los datos requeridos</small>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Tipo de documento *"
              label-cols-sm="12"
            >
              <b-button-group>
                <b-button
                  v-for="option in documentTypes"
                  :key="option.value"
                  :variant="form.document_type === option.value ? 'primary' : 'outline-secondary'"
                  class="rounded-pill px-4 font-weight-bold mr-1 mb-1"
                  @click="form.document_type = option.value"
                >
                  {{ option.text }}
                </b-button>
              </b-button-group>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Número de documento *"
              label-for="v-document-number"
            >
              <b-form-input
                id="v-document-number"
                v-model="form.document_number"
                placeholder=""
              />
              <div
                v-if="errors.document_number"
                class="text-danger"
              >
                {{ errors.document_number }}
              </div>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Nombre de la clínica *"
              label-for="v-clinic-name"
            >
              <b-form-input
                id="v-clinic-name"
                v-model="form.clinic_name"
                placeholder=""
              />
              <div
                v-if="errors.clinic_name"
                class="text-danger"
              >
                {{ errors.clinic_name }}
              </div>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Ciudad de la clínica"
              label-for="v-city"
            >
              <v-select
                id="v-city"
                v-model="form.city_id"
                :options="cities"
                label="text"
              />
              <div
                v-if="errors.city_id"
                class="text-danger"
              >
                {{ errors.city_id }}
              </div>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Dirección de la clínica"
              label-for="v-address"
            >
              <b-form-input
                id="v-address"
                v-model="form.clinic_address"
                placeholder="Carrera 77B # 30 - 50"
              />
              <div
                v-if="errors.clinic_address"
                class="text-danger"
              >
                {{ errors.clinic_address }}
              </div>
            </b-form-group>
          </b-col>

        </b-row>
      </tab-content>

      <!-- social link -->
      <tab-content
        title="Datos del paciente"
        :before-change="validationPatientDataForm"
      >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Datos del paciente
            </h5>
            <small class="text-muted">Ingresa los datos del cliente.</small>
          </b-col>

          <b-col md="12">
            <p>Ingresa los datos del paciente. Serán utilizados para enviar el mensaje de confirmación y recordatorio de la cita.</p>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Nombre completo del paciente *"
              label-for="v-patient-name"
            >
              <b-form-input
                id="v-patient-name"
                v-model="form.patient_name"
                placeholder=""
              />
              <div
                v-if="errors.patient_name"
                class="text-danger"
              >
                {{ errors.patient_name }}
              </div>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Celular del paciente *"
              label-for="v-cell-phone"
            >
              <b-form-input
                id="v-cell-phone"
                v-model="form.patient_phone"
                placeholder="3001234567"
              />
              <div
                v-if="errors.patient_phone"
                class="text-danger"
              >
                {{ errors.patient_phone }}
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        v-if="form.schedule_service_type_id === 1"
        title="Fecha y hora"
        :before-change="validationDateForm"
      >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Fecha y hora
            </h5>
            <small class="text-muted">Selecciona la fecha y hora disponible.</small>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Fecha *"
              label-for="v-date"
            >
              <b-form-datepicker
                v-model="form.date"
                :date-disabled-fn="dateDisabled"
                locale="es"
                @input="handleDateChange"
              />
              <div
                v-if="errors.date"
                class="text-danger"
              >
                {{ errors.date }}
              </div>
            </b-form-group>
          </b-col>

          <b-col
            v-if="availableTimes && availableTimes.available && !loadingDate"
            md="12"
          >
            <b-form-group
              label="Horario disponible *"
              label-cols-sm="12"
            >
              <div class="d-flex flex-wrap">
                <b-button
                  v-for="option in availableTimes.times"
                  :key="option"
                  :variant="form.time === option ? 'primary' : 'outline-secondary'"
                  class="rounded-pill px-4 font-weight-bold mr-1 mb-1"
                  @click="form.time = option"
                >
                  {{ option }}
                </b-button>
              </div>

              <div
                v-if="errors.time"
                class="text-danger"
              >
                {{ errors.time }}
              </div>
            </b-form-group>
          </b-col>
          <b-col
            v-if="availableTimes && availableTimes.available == false"
            md="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              {{ availableTimes.reason }}
            </h5>
            <p class="mb-0">
              {{ availableTimes.message }}
            </p>
          </b-col>

          <b-col
            v-if="loadingDate"
            md="12"
          >
            <loading-skeleton />
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Código de referido"
              label-for="v-referral-code"
            >
              <b-form-input
                id="v-referral-code"
                v-model="form.referral_code"
                placeholder=""
              />
            </b-form-group>
          </b-col>

        </b-row>
      </tab-content>

    </form-wizard>

    <form-skeleton v-if="isSubmitting" />

    <div v-if="user">
      <div class="text-right">
        <small>Usuario logueado para agendar</small>
        <h5 class="">
          {{ user.full_name }}, {{ user.role.name }}
        </h5>
        <a
          href="#"
          @click.prevent="logoutSchedules"
        >Salir</a>
      </div>
    </div>

  </div>
  <div v-else>
    <loading-skeleton />
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput, BButton, BForm, BInputGroup, BInputGroupAppend, BAlert, BSpinner, BCardTitle, BCardText, BFormDatepicker, BButtonGroup,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { codeDisableDate } from '@/views/forms/form-element/form-datepicker/code'
import api from '@/plugin/axios'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import LoadingSkeleton from '@/views/misc/LoadingSkeleton.vue'
import FormSkeleton from '@/views/misc/FormSkeleton.vue'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  components: {
    LoadingSkeleton,
    FormSkeleton,
    BFormDatepicker,
    BCardText,
    BCardTitle,
    BSpinner,
    BAlert,
    BInputGroupAppend,
    BInputGroup,
    BForm,
    ValidationProvider,
    BButton,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormDatepicker,
    BButtonGroup,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: false,
      loadingDate: false,
      password: null,
      userEmail: null,
      user: null,
      userExists: null,
      selectedDocument: 'CC',
      form: {
        // General
        schedule_service_type_id: null, // Escaneo o Impresión de modelo
        scan_type_id: null, // Solo si selecciona Escaneo
        model_type: null, // Solo si selecciona Impresión (Superior, Inferior, ambos)

        // Clínica
        schedule_clinic_id: null, // Selecciona si ya está registrada
        document_type: 'CC', // Solo si va a crear clínica
        document_number: '',
        clinic_name: '',
        clinic_address: '',
        city_id: null,

        // Odontólogo
        dentist_id: null, // Se autocompleta si está logueado
        dentist_name: '', // Solo si no está logueado

        // Paciente
        patient_id: null, // Selección o creación
        patient_name: '',
        patient_phone: '',

        // Agenda
        date: null,
        time: null,

        // Extra
        referral_code: '',
      },
      services: null,
      scanTypes: null,
      modelTypes: [
        { text: 'Inferiores', value: 'inferior' },
        { text: 'Superiores', value: 'superior' },
        { text: 'Ambos', value: 'ambos' },
      ],
      availableTimes: null,
      documentTypes: [
        { text: 'C.C', value: 'CC' },
        { text: 'NIT', value: 'NIT' },
      ],
      selectedServiceType: null,
      selectedScanType: null,

      errors: {},

      dataAppointments: null,
      cities: null,

      value: '',
      codeDisableDate,

      isSubmitting: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'form.schedule_service_type_id': function () {
      this.form.model_type = null
      this.form.scan_type_id = null
      console.log('entra')
    },
  },
  mounted() {
    this.userExists = !!localStorage.getItem('userSchedule')
    if (this.userExists) {
      const userData = localStorage.getItem('userSchedule')
      this.user = JSON.parse(userData)
    }
  },
  created() {
    this.getDataCreate()
  },
  methods: {
    async formSubmitted() {
      this.isSubmitting = true
      try {
        const response = await api.post('/api/appointments', {
          // General
          schedule_service_type_id: this.form.schedule_service_type_id,
          scan_type_id: this.form.scan_type_id,
          model_type: this.form.model_type,

          // Clínica
          schedule_clinic_id: this.form.schedule_clinic_id,
          document_type: this.form.document_type,
          document_number: this.form.document_number,
          clinic_name: this.form.clinic_name,
          clinic_address: this.form.clinic_address,
          city_id: this.form.city_id.value,

          // Odontólogo
          dentist_id: this.user.id,
          dentist_name: this.form.dentist_name,

          // Paciente
          patient_id: this.form.patient_id,
          patient_name: this.form.patient_name,
          patient_phone: this.form.patient_phone,

          // Agenda
          date: this.form.date,
          time: this.form.time,

          // Extra
          referral_code: this.form.referral_code,
        })

        // Manejo de respuesta exitosa
        console.log('Agendamiento exitoso:', response.data)

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Agendamiento exitoso',
            icon: 'EditIcon',
            variant: 'Cita agendada correctamente',
          },
        })
        this.$router.push({ name: 'schedule-resume', params: { id: response.data.data.id } })
      } catch (error) {
        console.error('Error al guardar agendamiento:', error)
        this.$toast.error('No se pudo agendar la cita')
      } finally {
        this.isSubmitting = false
      }
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationServicesForm() {
      this.errors = {} // Limpiar errores previos

      // Validación personalizada
      if (!this.form.schedule_service_type_id) {
        this.errors.schedule_service_type_id = 'Seleccione un tipo de servicio'
      }

      if (this.form.schedule_service_type_id === 1 && !this.form.scan_type_id) {
        this.errors.scan_type_id = 'Seleccione un tipo de escaneo'
      }

      if (this.form.schedule_service_type_id === 2 && !this.form.model_type) {
        this.errors.model_type = 'Seleccione un modelo'
      }

      // Validaciones adicionales (ejemplo con otro campo)
      /* if (!this.form.date) {
        this.errors.date = 'Seleccione una fecha'
      } */

      // Retornar true si no hay errores
      return Object.keys(this.errors).length === 0
    },
    validationClinicDataForm() {
      this.errors = {} // Limpiar errores previos

      if (!this.form.document_number) {
        this.errors.document_number = 'El número de documento es obligatorio'
      }

      if (!this.form.clinic_name) {
        this.errors.clinic_name = 'El nombre de la clínica es obligatorio'
      }

      if (!this.form.city_id) {
        this.errors.city_id = 'Seleccione una ciudad'
      }

      if (!this.form.clinic_address) {
        this.errors.clinic_address = 'La dirección es obligatoria'
      }

      /* if (!this.form.dentist_name) {
        this.errors.dentist_name = 'El nombre del profesional es obligatorio'
      } */

      // Validaciones adicionales (ejemplo con otro campo)
      /* if (!this.form.date) {
        this.errors.date = 'Seleccione una fecha'
      } */

      // Retornar true si no hay errores
      return Object.keys(this.errors).length === 0
    },
    validationPatientDataForm() {
      this.errors = {} // Limpiar errores previos

      if (!this.form.patient_phone) {
        this.errors.patient_phone = 'La celular del paciente es obligatorio'
      }

      if (!this.form.patient_name) {
        this.errors.patient_name = 'El nombre del paciente es obligatorio'
      }

      // Validaciones adicionales (ejemplo con otro campo)
      /* if (!this.form.date) {
        this.errors.date = 'Seleccione una fecha'
      } */

      // Retornar true si no hay errores
      return Object.keys(this.errors).length === 0
    },
    validationDateForm() {
      this.errors = {} // Limpiar errores previos

      if (!this.form.date) {
        this.errors.date = 'La fecha es obligatoria'
      }

      if (!this.form.time) {
        this.errors.time = 'El hora es obligatoria'
      }

      // Validaciones adicionales (ejemplo con otro campo)
      /* if (!this.form.date) {
        this.errors.date = 'Seleccione una fecha'
      } */

      // Retornar true si no hay errores
      return Object.keys(this.errors).length === 0
    },
    validationUserLogin() {
      this.errors = {} // Limpiar errores previos

      if (!this.user) {
        this.errors.user = 'Debes iniciar sesión para continuar'
      }

      // Retornar true si no hay errores
      return Object.keys(this.errors).length === 0
    },
    async getDataCreate() {
      [this.dataAppointments] = await Promise.all([
        api.get('/api/appointments/create'),
      ])

      console.log(this.dataAppointments)

      this.services = this.dataAppointments.data.services.map(service => ({ value: service.id, text: service.name }))
      this.scanTypes = this.dataAppointments.data.scan_types.map(scanType => ({ value: scanType.id, text: scanType.name }))
      this.cities = this.dataAppointments.data.cities.map(city => ({ value: city.id, text: city.name }))
      // this.clinics = this.dataAppointments.data.clinics.map(clinic => ({ value: clinic.clinic_detail.id, text: clinic.first_name }))
      // this.dentists = this.dataAppointments.data.dentists.map(dentist => ({ value: dentist.id, text: dentist.full_name }))

      /* if (this.userData.role_id === 5) {
        this.order.dentist_id = this.userData.id // Forzar selección de "Paciente"
        this.dentists = this.dentists.filter(dentists => dentists.value === this.userData.id)
      } */

      // this.patients = this.dataAppointments.data.patients.map(patient => ({ value: patient.id, text: `${patient.full_name} - ${patient.document_type}: ${patient.document_number}` }))
    },
    handleDateChange(newDate) {
      this.getAvailableTimes()
    },
    async getAvailableTimes() {
      this.loadingDate = true
      this.form.time = null
      try {
        const response = await api.get('/api/appointments/available-times', {
          params: {
            date: this.form.date,
            service_id: this.form.schedule_service_type_id,
          },
        })
        this.availableTimes = response.data
      } catch (error) {
        console.error('Error al obtener horarios disponibles:', error)
      } finally {
        this.loadingDate = false
      }
    },
    dateDisabled(ymd, date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0) // Limpiamos horas para comparar solo fechas

      const current = new Date(date)
      current.setHours(0, 0, 0, 0)

      const isPast = current < today
      const isSunday = current.getDay() === 0

      // Deshabilita si es domingo o es una fecha pasada
      return isSunday || isPast
    },
    async login() {
      this.loading = true
      try {
        const response = await api.post('/api/auth/login', {
          email: this.userEmail,
          password: this.password,
        })

        const { user } = response.data

        if (user.role.id === 5) {
          await localStorage.setItem('userSchedule', JSON.stringify(user))
          this.user = user
        } else {
          this.$bvToast.toast('Solo pueden agendar citas los odontólogos', {
            title: 'Importante',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        }
      } catch (error) {
        console.log(error.response)
        if (error.response && error.response.data.errors) {
          const messages = Object.values(error.response.data.errors).flat().join('\n')

          this.$bvToast.toast(messages, {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        } else if (error.response && error.response.data.message) {
          const messages = error.response.data.message

          this.$bvToast.toast(messages, {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        } else {
          this.$bvToast.toast('Ocurrió un error inesperado.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        }
      } finally {
        this.loading = false
      }
    },
    logoutSchedules() {
      localStorage.removeItem('userSchedule')
      this.user = null
      this.userExists = false
    },
  },
}
</script>

<style scoped>
.b-button-group .btn {
  transition: 0.2s;
  font-size: 1.1rem;
}
</style>
